const config = {
  api_method: 'https',
  api_server: 'api.famcare.jp',
  api_version: 'v2'
}

switch (process.env.NODE_ENV) {
  case 'development':
    config.api_method = 'http'
    config.api_server = '192.168.33.10:3000'
    // 社員・店舗
    config.syainsoshiki = {
      method: 'http',
      server: '192.168.33.10:8081',
      auth: '/static/html/redirect.html',
      redirect: '/#/users'
    }
    // google map api key
    config.google_map_api_key = 'AIzaSyCCVhzjI92Q4IMnCLxae15yuNxDjTaAvb0'
    break
  case 'testing':
    break
  case 'staging':
    config.api_method = 'http'
    config.api_server = 'famcareapi.diffeasy.com'
    // 社員・店舗
    config.syainsoshiki = {
      method: 'http',
      server: 'syainsoshiki.diffeasy.com',
      auth: '/static/html/redirect.html',
      redirect: '/#/users'
    }
    // google map api key
    config.google_map_api_key = 'AIzaSyCCVhzjI92Q4IMnCLxae15yuNxDjTaAvb0'
    break
  case 'staging-gcp':
    config.api_method = 'https'
    config.api_server = 'staging-api.famcare.jp'
    // 社員・店舗
    config.syainsoshiki = {
      method: 'https',
      server: 'staging-master.famcare.jp',
      auth: '/static/html/redirect.html',
      redirect: '/#/users'
    }
    // google map api key
    config.google_map_api_key = 'AIzaSyCCVhzjI92Q4IMnCLxae15yuNxDjTaAvb0'
    break
  case 'pkg-gcp':
    config.api_method = 'https'
    config.api_server = 'pkg-api.famcare.jp'
    // 社員・店舗
    config.syainsoshiki = {
      method: 'https',
      server: 'hana.master.famcare.jp',
      auth: '/static/html/redirect.html',
      redirect: '/#/users'
    }
    // google map api key
    config.google_map_api_key = 'AIzaSyCCVhzjI92Q4IMnCLxae15yuNxDjTaAvb0'
    break
  case 'production':
    config.api_method = 'https'
    config.api_server = 'api.famcare.jp'
    // 社員・店舗
    config.syainsoshiki = {
      method: 'https',
      server: 'master.kirari0309.co.jp',
      auth: '/static/html/redirect.html',
      redirect: '/#/users'
    }
    // google map api key
    config.google_map_api_key = 'AIzaSyCCVhzjI92Q4IMnCLxae15yuNxDjTaAvb0'
    break
}

export default config



// WEBPACK FOOTER //
// ./src/store/config.js